import React from "react";
import PropTypes from "prop-types";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const LineChartVersion2 = ({
  data,
  xAxisDataKey,
  lineDataKeys,
  colors = ["#8884d8", "#82ca9d", "#ffc658"],
  width = "100%",
  height = "100%",
  margin = { top: 5, right: 5, left: 20, bottom: 5 },
  showGrid = false,
  showLegend = false,
  showTooltip = true,
  gridProps = { strokeDasharray: "3 3" },
  chartProps = {},
}) => {
  // Calculate min and max values for YAxis domain
  const allValues = data
    ?.flatMap((item) => lineDataKeys?.map((key) => item[key]))
    .filter((value) => typeof value === "number");

  const minValue = Math?.min(...allValues);
  const maxValue = Math?.max(...allValues);

  return (
    <ResponsiveContainer width={width} height={height}>
      <LineChart data={data} margin={margin} {...chartProps}>
        {showGrid && <CartesianGrid {...gridProps} />}
        <XAxis dataKey={xAxisDataKey} tick={{ fontSize: 10 }} tickMargin={5} />
        <YAxis
          tick={{ fontSize: 10 }}
          width={30}
          domain={[minValue * 0.9, maxValue * 1.1]}
          tickCount={5}
          axisLine={false}
        />
        {showTooltip && <Tooltip />}
        {showLegend && (
          <Legend
            wrapperStyle={{
              paddingTop: "5px",
              fontSize: "12px",
            }}
          />
        )}
        {lineDataKeys.map((dataKey, index) => (
          <Line
            key={dataKey}
            type="monotone"
            dataKey={dataKey}
            stroke={colors[index % colors.length]}
            strokeWidth={2}
            activeDot={{ r: 4 }}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

LineChartVersion2.propTypes = {
  data: PropTypes.array.isRequired,
  xAxisDataKey: PropTypes.string.isRequired,
  lineDataKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  margin: PropTypes.object,
  showGrid: PropTypes.bool,
  showLegend: PropTypes.bool,
  showTooltip: PropTypes.bool,
  gridProps: PropTypes.object,
  chartProps: PropTypes.object,
};

LineChartVersion2.defaultProps = {
  colors: ["#8884d8", "#82ca9d", "#ffc658"],
  showLegend: false,
};

export default LineChartVersion2;
